import { render, staticRenderFns } from "./TelphoneAverageTimeChart.vue?vue&type=template&id=5c71f699"
import script from "./TelphoneAverageTimeChart.vue?vue&type=script&lang=js"
export * from "./TelphoneAverageTimeChart.vue?vue&type=script&lang=js"
import style0 from "./TelphoneAverageTimeChart.vue?vue&type=style&index=0&id=5c71f699&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports